// Common functions across our mosaic_v2 widget LayoutView.
import _ from 'global/underscore';

// Common regions in the layout.
export const regions = {
    widgetHeaderRegion: '#widget_header_region',
    interactiveRegion: '#interactive_region',
    frame: '.mosaic_frame'
};
export const ui = {
    loadMore: '.load_more',
    mosaicControl: '#mosaic_control'
};

export const collectionEvents = {
    'sync': 'collectionChange',
    'reset': 'collectionChange'
};

export const events = { 'click .load_more': 'loadMore' };

// Initialises this LayoutView.
export function initialize(displayOptions) {
    this.firstLoad = true;
    this.displayOptions = displayOptions;
    this.infiniteLoadOption = this.displayOptions.get('infiniteLoadMore');
    // Slight debounce for when 'sync' and 'reset' are triggered at the same time
    this.debounceReloadIsotope = _.debounce(onReloadIsotope.bind(this), 200);
};

export function onShow() {
    // Check if 'infiniteLoadMore' display option is enabled
    if (!_.isFalsy(this.infiniteLoadOption)) {
        this.ui.loadMore.addClass('loading').hide();
        this.waitForLoadMoreRequest();
    }
};

/*
 * Initializes Isotope, a JS library we use to make masonry-style layouts.
 */
export function onInitIsotope() {
    this.grid = $('.clearfix').isotope({
        layoutMode: 'packery',
        itemSelector: '.photo_block',
        transitionDuration: 0
    });
}

// Reloads Isotope, to update the grid.
function onReloadIsotope() {
    const loadMore = this.checkMosaicLoadMore();
    if (!_.isFalsy(this.grid)) {
        this.grid.imagesLoaded().progress(function() {
            this.grid.isotope('reloadItems');
            onInitIsotope.call(this);
        }.bind(this));
    }
    if (loadMore) {
        this.ui.loadMore.show();
    } else {
        this.ui.loadMore.hide();
    }
}

// Redisplay the grid when the collection changes.
export function collectionChange() {
    // firstLoad may be overkill but it will make the widget as fast as possible
    if (this.firstLoad) {
        this.firstLoad = false;
        onReloadIsotope.call(this);
    } else {
        this.debounceReloadIsotope();
    }
}

// If the collection has more content, update the UI accordingly.
export function infiniteLoadMore(app) {
    if (this.collection.next) {
        this.ui.loadMore.show();
        this.collection.nextPage({
            success: function() {
                if (this.finishedFirstLoad) {
                    app.commands.execute('load:more', this.collection.pluck('album_photo_id'));
                }
                this.finishedFirstLoad = true;
                this.ui.loadMore.hide();
                this.is_loading = false;
            }.bind(this)
        });
    } else {
        this.is_loading = false;
    }
};

export function waitForLoadMoreRequest(win) {
    const receiveMessage = _.debounce(function(event) {
        try {
            var eventData = JSON.parse(event.data);
            if (eventData.name === 'pixlee:infinite:load:more' && !this.is_loading) {
                this.is_loading = true;
                this.infiniteLoadMore();
            }
        } catch (e) {
            return;
        }
    }.bind(this), 500);
    win.addEventListener('message', receiveMessage, false);
}


/* Checks whether we have more content to load.
 * @return boolean
 */
export function checkMosaicLoadMore() {
    // Check if there's a next page for 'mosaic infinite load'
    const infiniteLoadNextPage = !_.isFalsy(this.infiniteLoadOption) && this.collection.next;

    // Check if there's a next page for 'perfact mosaic'
    const queueModel = this.collection.findWhere({
        'queueModel': true
    });
    // If there is a queue model, the collection is empty but there still could be a next page
    const perfectMosaicNextPage = _.isFalsy(this.infiniteLoadOption) && (this.collection.next || !queueModel);

    return infiniteLoadNextPage || perfectMosaicNextPage;
}
